const FIGURE_CLASS = {
	LOADING: 'loading',
	LOADED: 'loaded',
	CLICKED: 'clicked',
	SHOW_COVER: 'show-cover',
	SHOW_VIDEO_COVER: 'show-video-cover',
	YOUTUBE_VIDEO_WITH_VIDEO_COVER: 'youtube-video-with-video-cover',
	CDSVIDEO_WITH_VIDEO_COVER: 'cdsvideo-with-video-cover',
	PLAIN_VIDEO: 'plain-video',
	PLAIN_VIDEO_WITH_COVER: 'plain-video-with-cover',
};

export {
	FIGURE_CLASS,
};
